import React, { useState, useEffect } from 'react';
import { RichUtils, EditorState } from 'draft-js';
import { getSelectionInlineStyle } from 'draftjs-utils';

// Constants
import ToolbarConfig from '../../Toolbar/toolbar.config';

// Components
import Control from '../Control/Control';

type Props = {
  editorState: EditorState;
  onChange?: Function;
  style: string;
};

const Inline = ({ editorState, onChange, style }: Props) => {
  const [currentStyles, setCurrentStyle] = useState(getSelectionInlineStyle(editorState));
  const config = ToolbarConfig.find(item => item.style === style);

  const toggleStyling = () => {
    const newStyle = style.toUpperCase();
    const newState = RichUtils.toggleInlineStyle(editorState, newStyle);

    if (newState) {
      onChange(newState);
    }
  };

  useEffect(() => {
    setCurrentStyle(getSelectionInlineStyle(editorState));
  }, [editorState]);

  return (
    <Control key={config.style} icon={config.icon} onClick={toggleStyling} active={currentStyles[style] === true} />
  );
};

export default Inline;
